/**
 * Normalize dashboard / vw_Dashboard TableName values to the calendar-style names
 * used by HomePage form routing and getTableRecord mappings.
 */
export function normalizeDashboardTableNameForCalendar(raw) {
  if (raw == null || raw === '') return '';
  const t = String(raw).trim();
  const map = {
    Compliance_Records: 'Compliance',
    SPCC_Annual_Inspections: 'SPCC_Annual',
    AnnualSPCC: 'SPCC_Annual',
    SPCC_Routine_Inspections: 'SPCC_Routine',
    RoutineSPCC: 'SPCC_Routine',
    SWPPP_Quarterly_Inspections: 'SWPPP_Quarterly',
    SWPPPFacility: 'SWPPP_Quarterly',
    SWPPP_Discharge_Monitoring_Inspections: 'SWPPP_Discharge_Monitoring',
    SWPPPDischarge: 'SWPPP_Discharge_Monitoring',
    Sump_Pump_Maintenance_Inspections: 'SumpPumpMaintenance',
    SumpPump: 'SumpPumpMaintenance',
    Transfer_Hose_and_Pipe_Tests: 'TransferHoseAndPipeTesting',
    TransferHose: 'TransferHoseAndPipeTesting',
    DrainageRecordation: 'DrainageRecordation',
    EnvironmentalSampling: 'EnvironmentalSampling',
    EnvironmentalLabAnalysis: 'EnvironmentalLabAnalysis',
    Equipment_Deployment_Ex_Logs: 'Equipment_Deployment_Ex_Logs',
    EquipmentDeployment: 'Equipment_Deployment_Ex_Logs',
    QI_Notification_Ex_Logs: 'QI_Notification_Ex_Logs',
    QI: 'QI_Notification_Ex_Logs',
    Tabletop_Annual_Ex_Logs: 'Tabletop_Annual_Ex_Logs',
    Tabletop: 'Tabletop_Annual_Ex_Logs',
    Response_Equipment_Inventory_Inspections: 'Response_Equipment_Inventory_Inspections',
    Response: 'Response_Equipment_Inventory_Inspections',
    ComplianceVerificationMaster: 'Compliance_Master',
    VerificationDetails: 'Compliance_Master'
  };
  return map[t] || t;
}
